export default {
  'offer-status': "Offer Status",
  'offer-no': "Offer Number",
  'payment-terms': "Payment Terms",
  'validity-days': "Offer Validity Period"
}
